const postsStyleCarousel = (Swiper, FreeMode, Navigation) => {
  
  const psCarousel = document.querySelectorAll('.posts-style-carousel .swiper');
  
  if (psCarousel !== null) {
    
		psCarousel.forEach((el) => {
			
			if (el.classList.contains('testimonial-swiper')) {
				
				let swiper = new Swiper(el, {
					modules: [FreeMode, Navigation],
					speed: 1000,
					slidesPerView: 1,
					spaceBetween: 32,
					loop: false,
					breakpoints: {
						656: {
							slidesPerView: 2
						}
					},
					freeMode: {
						enabled: true,
						sticky: true,
					},
					navigation: {
						nextEl: ".csc-button-next",
						prevEl: ".csc-button-prev",
					}
				});
				
			} else {
				
				let swiper = new Swiper(el, {
					modules: [FreeMode, Navigation],
					speed: 1000,
					slidesPerView: 1,
					spaceBetween: 32,
					loop: false,
					breakpoints: {
						656: {
							slidesPerView: 2
						},
						992: {
							slidesPerView: 3
						}
					},
					freeMode: {
						enabled: true,
						sticky: true,
					},
					navigation: {
						nextEl: ".csc-button-next",
						prevEl: ".csc-button-prev",
					}
				});
				
			}
			
		});
		
  }
  
}

export {
  postsStyleCarousel
};